/** The box a GPUParticles3D gives its instance: its `visibility_aabb` (`particles_storage.cpp:691-696`). */
export function useGPUParticles3DAabb(node) {
    return node.properties.visibilityAabb;
}
//# sourceMappingURL=ownAabb.js.map